<template>
  <SlDialog
    title="上传合同"
    :visible.sync="dialogVisible"
    width="40%"
    :close-on-click-modal="false"
    :lock-scroll="false"
    @closed="resetDialog"
  >
    <el-form label-width="110px">
      <el-form-item label="生产订单号">
        <span>{{ currentRow.purchaseOrderNumber || '-' }}</span>
      </el-form-item>
      <el-form-item label="业务合同文件">
        <el-upload
          ref="upload"
          action="#"
          :auto-upload="false"
          :limit="1"
          :file-list="fileList"
          accept=".pdf"
          :before-upload="beforeUpload"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          :on-exceed="handleExceed"
        >
          <el-button type="primary" size="small">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">仅支持上传 PDF 格式文件</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <template v-slot:bottom>
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
    </template>
  </SlDialog>
</template>

<script>
import OemGoodsAPI from '@api/oemGoods'

const ACCEPT_FILE_SUFFIXS = ['.pdf']

export default {
  name: 'ContractUploadDialog',
  data () {
    return {
      dialogVisible: false,
      loading: false,
      currentRow: {},
      fileList: []
    }
  },
  methods: {
    openDialog (row) {
      this.currentRow = row || {}
      this.dialogVisible = true
    },
    beforeUpload (file) {
      return this.validateFile(file)
    },
    handleFileChange (file, fileList) {
      if (!this.validateFile(file.raw || file)) {
        this.fileList = []
        return
      }
      this.fileList = fileList.slice(-1)
    },
    handleFileRemove (file, fileList) {
      this.fileList = fileList
    },
    handleExceed () {
      this.$message.error('只能上传一个合同文件')
    },
    validateFile (file) {
      if (!file || !file.name) {
        return false
      }
      const fileName = file.name.toLowerCase()
      const isValid = ACCEPT_FILE_SUFFIXS.some(suffix => fileName.endsWith(suffix))
      if (!isValid) {
        this.$message.error('仅支持上传 PDF 格式文件')
      }
      return isValid
    },
    submit () {
      if (!this.fileList.length) {
        this.$message.error('请上传业务合同文件')
        return
      }

      const file = this.fileList[0]
      const rawFile = file.raw || file
      const purchaseOrderId = this.currentRow.purchaseOrderId
      if (!purchaseOrderId) {
        this.$message.error('生产订单ID缺失，无法上传合同')
        return
      }

      this.loading = true
      OemGoodsAPI.uploadContract(purchaseOrderId, rawFile).then(res => {
        if (res.success) {
          this.$message.success('合同文件上传成功')
          this.dialogVisible = false
          this.$emit('submit', res.data)
        }
      }).catch(() => {
        this.$message.error('合同文件上传失败')
      }).finally(() => {
        this.loading = false
      })
    },
    resetDialog () {
      this.currentRow = {}
      this.fileList = []
      this.loading = false
      this.$refs.upload && this.$refs.upload.clearFiles()
    }
  }
}
</script>
